import { Controller } from "@hotwired/stimulus";

// Ce contrôleur gère le comportement des blocs accordéon
export default class extends Controller {
  static targets = ["header", "content", "chevron"];

  connect() {
    console.log("Accordion controller connected");
  }

  // Toggle l'état ouvert/fermé d'un accordéon
  toggle(event) {
    const index = event.currentTarget.dataset.index;
    this.toggleAccordion(index);
  }

  // Ouvre ou ferme l'accordéon
  toggleAccordion(index) {
    const content = this.getContentByIndex(index);
    const chevron = this.getChevronByIndex(index);

    if (content.classList.contains("hidden")) {
      // Ouvrir l'accordéon
      content.classList.remove("hidden");
      chevron.classList.add("rotate-180");
    } else {
      // Fermer l'accordéon
      content.classList.add("hidden");
      chevron.classList.remove("rotate-180");
    }
  }

  // Récupère le contenu de l'accordéon par index
  getContentByIndex(index) {
    return this.contentTargets.find(
      (content) => content.dataset.index === index
    );
  }

  // Récupère le chevron de l'accordéon par index
  getChevronByIndex(index) {
    return this.chevronTargets.find(
      (chevron) => chevron.dataset.index === index
    );
  }
}
